import type { OtherActivity } from "../declarations/config";

export const otherActivities: OtherActivity[] = [
  {
    title: "Vzkazník",
    description: "Máš pro nás vzkaz nebo nápad? Napiš nám.",
    src: "/advent2024/napis-nam",
    thumbnail: "vzkaznik-icon.png",
    order: 1,
    slug: "napiste-nam",
  },
  {
    title: "Soutěž",
    description: "V adventních hrách se dá taky soutěžit! Zjisti víc.",
    src: "/advent2024/soutez",
    thumbnail: "soutez-icon.png",
    order: 2,
    slug: "soutez",
  },
  {
    title: "Vánoční hry",
    description: "Chceš si hrát víc? Tady najdeš další vánoční hry.",
    src: "/hry/vanocni",
    thumbnail: "hry-icon.png",
    order: 3,
    slug: "vanocni-hry",
  },
  {
    title: "Gramofon",
    description: "Čtyřiadvacet vánočních písniček pro tvé ouško.",
    src: "/hry/gramofon-advent2024",
    thumbnail: "gramofon-icon.png",
    order: 4,
    slug: "gramofon",
  },
  {
    title: "Komiks",
    description: "Příběh Ježíškova narození pěkně políčko po políčku.",
    src: "/hry/adventni-komiks",
    thumbnail: "komiks-icon.png",
    order: 5,
    slug: "adventni-komiks",
  },
  {
    title: "Galerie",
    description: "Podívej se na prastaré obrazy rentgenovýma očima.",
    src: "/hry/co-skryvaji-obrazy",
    thumbnail: "galerie-icon.png",
    order: 6,
    slug: "galerie",
  },
  {
    title: "Tradičník",
    description: "Vysvětlíme ti kouzlo zlatých prasátek a dalších zvyků",
    src: "/hry/tradicnik",
    thumbnail: "tradicnik-icon.png",
    order: 7,
    slug: "tradicnik",
  },
  {
    title: "Archiv",
    description: "Vzpomínáš na minulé kalendáře? Tady si můžeš brouzdat.",
    src: "/adventni-kalendare",
    thumbnail: "archiv-icon.png",
    order: 8,
    slug: "archiv",
  },
  {
    title: "O projektu",
    description: "Tady se dozvíš, kdo pro tebe adventní kalendář vyrobil.",
    src: "/advent2024/o-projektu",
    thumbnail: "projekt-icon.png",
    order: 9,
    slug: "o-projektu",
  },
];
